import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useRequotePreview = (applicationId, applied) => {
  const [executeCallable, loading, error] = useHttpsCallable(
    functions,
    "requotePreview"
  );
  const [complete, setComplete] = useState(false);
  const [preview, setPreview] = useState(false);
  useEffect(() => {
    setComplete(false);
    setPreview(false);
  }, [applicationId, applied]);
  const requotePreview = async ({
    mode,
    addonRate,
    term,
    repayment,
    costOfVessel,
    deposit,
    ignoreLimits,
    lookupRate,
    balloon,
  }) => {
    try {
      const result = await executeCallable({
        ...(mode === "term" ? { term } : { repayment }),
        // omit when unset so a standard quote sends the exact payload as before
        ...(balloon !== "" && balloon != null
          ? { balloon: Number(balloon) }
          : {}),
        mode,
        applicationId,
        addonRate,
        costOfVessel,
        deposit,
        ignoreLimits,
        lookupRate,
      });
      setComplete(true);
      if (!result?.data?.success) {
        console.error(result);
        throw new Error("Error requoting");
      }
      setPreview(result.data.quote);
      return true;
    } catch (err) {
      setComplete(false);
      setPreview(undefined);
      return false;
    }
  };
  return {
    loading,
    error,
    preview,
    success: !loading && !error && complete,
    requotePreview,
  };
};
